import { mapGetters } from 'vuex'
export default {
  computed: {
    ...mapGetters(['getUsername', 'userID']),
    getEnc(){
        return this.$route.query.enc ? `?enc=${this.$route.query.enc}` : ''
    },
    menuData() {
      return `<?xml version="1.0" encoding="utf-8"?>
      <!DOCTYPE html PUBLIC "-//W3C//DTD XHTML 1.0 Transitional//EN" "http://www.w3.org/TR/xhtml1/DTD/xhtml1-transitional.dtd">
      <html xmlns="http://www.w3.org/1999/xhtml" xml:lang="lt" lang="lt">
      <head>
          <meta http-equiv="content-type"
                content="text/html; charset=utf-8"/>
          <meta name="viewport" content="width=device-width, initial-scale=1.0"/>
          <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/style.css" type="text/css"/>
          <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/components.css" type="text/css"/>
          <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/new/components.css" type="text/css"/>
          <link rel="stylesheet" href="https://appdevel4.kada.lt/savitarna/css/print.css" type="text/css" media="print"/>
          <!-- Pridėti pagal tab spalvą -->
          <title>VĮRC Savitarna</title>
      </head>
          <body>
          <div id="info-panel">
              <div class="user-info">
      ${this.userID} ${this.getUsername}
              </div>
              <div class="site-info">
                  <a class="logout" href="https://appdevel4.kada.lt/savitarna/logout.do">Baigti darbą</a>
                  <a class="localeEN" href="${this.getEnc}?accessibility=1"> a </a>
                  <a class="localeEN" href="${this.getEnc}?accessibility=0"> n </a>
                  <a class="localeEN" href="${this.getEnc}?lang=en"> EN </a>
                  <a class="localeLT" href="${this.getEnc}?lang=lt"> LT </a>
              <style>
                  .localeLT {
                      padding: 0 0 4px;
                      margin-left: 8px;
                      color: #000000;
                      font-weight: bold;
                  }
              </style>
              </div>
          </div>
          <div id="container-in">
              <div id="header-in">
                  <div class="logo-container">
                    <a id="sav_rcLogo2" href="http://www.registrucentras.lt">
                          <img src="https://w2.registrucentras.lt/savitarna/images/RC_NAUJAS.png"
                               alt=""
                               border="0"/>
                      </a>
                  </div>
                  <div class="new-cart-container" style="width: 122px;">
                      <img src="https://w2.registrucentras.lt/savitarna/images/new_user_ico.gif"
                           alt="Mano pirkimai"
                           border="0"/>
                      <div>
                          <a id="sav_purchases" href="
              https://appdevel4.kada.lt/savitarna/myData.do
      ">Mano pirkimai</a><br/>
                          Mokėjimai, istorija
                      </div>
                  </div>
                  <div class="new-cart-container" style="width: 155px;">
                      <img src="https://w2.registrucentras.lt/savitarna/images/new_cart_ico.gif"
                           alt="Krepšelis"
                           border="0"/>
                      <div>
                          <a id="sav_basket" href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=13
      ">
                              Krepšelis
                              (0)
                          </a><br/>
                          0.00 €
                      </div>
                  </div>
                      <div class="new-cart-container" style="width: 275px;">
                          <img src="https://w2.registrucentras.lt/savitarna/images/new/money.png"
                               alt="Avansas"
                               border="0"/>
                          <div style="margin-top: 5px;">
                              <a id="sav_advance" href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=115
      ">
                                  Avansas
                              </a><br/>
                          </div>
                          <div>
                              Likutis - 0.00 €</br> Rezervuota - 0.00 €
                          </div>
                      </div>
                  <ul class="main-tabs">
                              <li class=" active">
                                  <a href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=1
      ">
                                      <span style="width: 103px;" class="sv-savitarna"></span>
                                  </a>
                              </li>
                  </ul>
                  <div class="tabs-container">
                      <ul class="tabs">
                                  <li class="">
                                      <a class="ntr"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=4
      ">
                                          <span style="margin-left: 16px; margin-right: 16px;">&nbsp;</span>
                                      </a>
                                  </li>
                                  <li class="">
                                      <a class="jar"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=23
      ">
                                          <span style="margin-left: 16px; margin-right: 16px;">&nbsp;</span>
                                      </a>
                                  </li>
                                  <li class="">
                                      <a class="ar"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=3
      ">
                                          <span style="margin-left: 16px; margin-right: 16px;">&nbsp;</span>
                                      </a>
                                  </li>
                                  <li class="">
                                      <a class="sc"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=2
      ">
                                          <span style="margin-left: 16px; margin-right: 16px;">&nbsp;</span>
                                      </a>
                                  </li>
                                  <li class="">
                                      <a class="gr"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=6
      ">
                                          <span style="margin-left: 16px; margin-right: 16px;">&nbsp;</span>
                                      </a>
                                  </li>
                                  <li class="active">
                                      <a class="ir"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=5
      ">
                                          <span style="margin-left: 16px; margin-right: 16px;">&nbsp;</span>
                                      </a>
                                  </li>
                                  <li class="">
                                      <a class="stsr"
                                         href="
              https://appdevel4.kada.lt/savitarna/goto.do?menuId=7
      ">
                                          <span style="margin-left: 12px; margin-right: 12px;">&nbsp;</span>
                                      </a>
                                  </li>
                      </ul>
                      <div class="tabs-right"></div>
                  </div>
              </div>
              <div id="content-in">
            <div class="left">
            local menu
              <ul class="side-menu">
                <li>
                  <a  href="/new-mandate${this.getEnc}">
                    Naujas įgaliojimas
                  </a>
                </li>
                <li>
                <a  href="/new-procuration${this.getEnc}">
                  Nauja prokūra
                </a>
              </li>
                <li>
                  <a  href="/mandates${this.getEnc}">
                    Mano įgaliojimai
                  </a>
                </li>
                <li>
                <a  href="/procurations${this.getEnc}">
                  Mano prokūros
                </a>
              </li>
                <li>
                  <a  href="/documents${this.getEnc}">
                    Mano rengiami ar registrui pateikti dokumentai
                  </a>
                </li>
                <li>
                  <a class=" " href="/orders${this.getEnc}">
                    Išrašų užsakymas
                  </a>
                </li>
                <li>
                  <a class=" " href="/notifications${this.getEnc}">
                    Iš registro gauti pranešimai
                  </a>
                </li>
              </ul>
              </div>
        <div class="content-info">
        <ul class="path">




        <li>
            <a href="









https://appdevel4.kada.lt/savitarna/goto.do?menuId=1

">Pradžia</a>
        </li>
        <li>/</li>






















            <li>
                <a href="









https://appdevel4.kada.lt/savitarna/goto.do?menuId=7

">















Įgaliojimų registras



                </a>
            </li>
            <li>/</li>






</ul>
            <div class="print-top">
                <a href="#" onclick="printDiv('print')">Spausdinti</a>
            </div>
            `
    },
    footerData() {
      return `
      <div class="up-bottom">
      <a href="#">Į viršų</a>
  </div>
  <div class="question-bottom">
      <a href="http://info.registrucentras.lt/faq/klientu_savitarna"
         target="_blank">
          Kilo klausimų?
      </a>
  </div>
</div>
<div class="clear-float"></div>
</div>
</div>
<div id="footer-in">
<div>
<p class="left" style="width: 24%; "><b>Valstybės įmonė Registrų centras</b><br/>Lvovo g. 25-101, 09320 Vilnius, Lietuva<br/>Tel. (8 5) 268 8262<br/>El. p. info@registrucentras.lt<br/>Įmonės kodas 124110246<br/></p>
<p class="left" style="width: 35%; text-align:right !important; padding-right:45px;"><a href="https://appdevel4.kada.lt/bylos/savitarna/REGISTRU_CENTRO_SAVITARNOS_PASLAUGU_TEIKIMO_TAISYKLES.pdf" target="_blank">Savitarnos paslaugų teikimo taisyklės</a><br/><a href="https://appdevel4.kada.lt/bylos/savitarna/SAVITARNOJE_TVARKOMU_ASMENS_DUOMENU_APSAUGOS_APRASAS.pdf" target="_blank">Savitarnoje tvarkomų asmens duomenų apsaugos aprašas</a></p>
<p class="left" style="width: 16%;"><b>Konsultacijų centras</b><br/>Tel. (8 5) 268 8262<br/>Darbo laikas:<br/>I–IV 8.00–17.00 val.<br/>V 8.00–16.00 val.</p>
<p class="left" style="width: 20%; text-align:right !important;"><b>Pagalba ir konsultacijos internetu:</b><br/><a href="http://info.registrucentras.lt/faq/klientu_savitarna" target="_blank">Dažniausiai užduodami klausimai</a><br/><a href="http://info.registrucentras.lt/paklausti" target="_blank">Užduoti klausimą</a><br/><a href="https://www.registrucentras.lt/p/890">Pateikti skundą</a></p>
<p class="left footer-center" style="width: 100%; ">© 2019 Valstybės įmonė Registrų centras. Versija: 3.16.0</p>
</div>
</div>
<br/>
<!-- Versija:  -->
</body>
</html>
      `
    },
  },
}
